'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { ACTIONS, EVENTS } from '../../../tracking/events';
import { getUsageTracker } from '../../../tracking/usageTracker';
import I18n from 'I18n';
import { AuthTypePropType, AuthTypes, AUTH_TYPE_KEYS, DEVELOPER_API_KEY_DOCS_URL, OAUTH_DOCS_URL, PRIVATE_APPS_URL } from '../constants';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import Code from 'UIComponents/elements/Code';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UITextInput from 'UIComponents/input/UITextInput';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import UILink from 'UIComponents/link/UILink';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { isSendButtonDisabled } from '../utils/authUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class TryItPopover extends Component {
  constructor(props) {
    super(props);
    this.getDefaultState = () => {
      return {
        authType: this.props.authType,
        apiKey: this.props.apiKey || '',
        oAuthToken: this.props.oAuthToken || ''
      };
    };
    this.getAuthDetails = () => {
      const {
        authType,
        apiKey,
        oAuthToken
      } = this.state;
      return {
        authType,
        apiKey,
        oAuthToken
      };
    };
    this.onCancelButtonClick = () => {
      this.props.onCancelButtonClick();
      this.setState(this.getDefaultState());
    };
    this.onTrackHelpLinkClick = action => {
      this.tracker.track(EVENTS.HELP_LINK_INTERACTION, {
        action
      });
    };
    this.renderAuthTypeRadioInputs = () => {
      const {
        authType
      } = this.state;
      const {
        securityTypes
      } = this.props;
      return AUTH_TYPE_KEYS.filter(key => securityTypes.includes(key)).map(key => {
        return /*#__PURE__*/_jsx(UIRadioInput, {
          checked: authType === AuthTypes[key],
          className: "m-left-0 m-right-4",
          name: "auth-type",
          onChange: () => this.setState({
            authType: AuthTypes[key]
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `developer-docs-shared-components.tryIt.dropdown.${AuthTypes[key]}`
          })
        }, key);
      });
    };
    this.renderPopoverFooter = () => {
      const {
        doc,
        isConfirming,
        onSendRequestButtonClick
      } = this.props;
      const method = doc.api.method;
      const needsConfirmation = method !== 'get' && !isConfirming;
      const authDetails = this.getAuthDetails();
      let buttonText = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.tryIt.dropdown.send"
      });
      let buttonUse = 'tertiary';
      if (needsConfirmation) {
        buttonText = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.tryIt.dropdown.sendEllipse"
        });
      }
      if (isConfirming) {
        buttonText = /*#__PURE__*/_jsx(FormattedMessage, {
          message: `developer-docs-shared-components.tryIt.dropdown.confirmButton.${method}`
        });
        if (method === 'delete') {
          buttonUse = 'danger';
        }
      }
      return /*#__PURE__*/_jsxs("div", {
        className: "m-top-2",
        children: [/*#__PURE__*/_jsx(UIButton, {
          use: buttonUse,
          size: "small",
          onClick: () => onSendRequestButtonClick(authDetails),
          disabled: isSendButtonDisabled(authDetails, isConfirming),
          children: buttonText
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "tertiary-light",
          size: "small",
          onClick: this.onCancelButtonClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.tryIt.dropdown.cancel"
          })
        })]
      });
    };
    this.renderConfirmationContent = () => {
      const method = this.props.doc.api.method;
      return /*#__PURE__*/_jsxs("div", {
        className: "m-top-4",
        children: [/*#__PURE__*/_jsx(UIFormLabel, {
          className: "display-block",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `developer-docs-shared-components.tryIt.dropdown.confirm.${method}`
          })
        }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: `developer-docs-shared-components.tryIt.dropdown.confirmWarning.${method}_jsx`,
          elements: {
            code: Code
          }
        })]
      });
    };
    this.renderPopoverBody = () => {
      const {
        apiKey,
        authType,
        oAuthToken
      } = this.state;
      const {
        securityTypes,
        isConfirming
      } = this.props;
      const multipleAuthTypesEnabled = securityTypes.length > 1;
      if (isConfirming) {
        return this.renderConfirmationContent();
      }

      // Otherwise render standard authorization form
      return /*#__PURE__*/_jsxs("div", {
        className: "m-top-4",
        children: [multipleAuthTypesEnabled && /*#__PURE__*/_jsx(UIFormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.tryIt.dropdown.authTypeLabel"
          }),
          children: /*#__PURE__*/_jsx(UIToggleGroup, {
            className: "p-left-0",
            name: "auth-type",
            inline: true,
            children: this.renderAuthTypeRadioInputs()
          })
        }), /*#__PURE__*/_jsx(UIFormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `developer-docs-shared-components.tryIt.dropdown.${authType}`
          }),
          help: this.renderAuthFieldDescription(),
          children: /*#__PURE__*/_jsx(UITextInput, {
            autoFocus: true,
            onChange: ({
              target: {
                value
              }
            }) => this.setState({
              [authType === AuthTypes.OAUTH_TOKEN ? 'oAuthToken' : authType === AuthTypes.PRIVATE_APPS ? 'oAuthToken' : 'apiKey']: value
            }),
            placeholder: I18n.text(`developer-docs-shared-components.tryIt.dropdown.placeholder.${authType}`),
            value: authType === AuthTypes.OAUTH_TOKEN ? oAuthToken : authType === AuthTypes.PRIVATE_APPS ? oAuthToken : apiKey
          })
        })]
      });
    };
    this.state = this.getDefaultState();
    this.tracker = getUsageTracker();
  }
  renderAuthFieldDescription() {
    const {
      authType
    } = this.state;
    switch (authType) {
      case AuthTypes.DEVELOPER_API_KEY:
        return /*#__PURE__*/_jsx(UILink, {
          href: DEVELOPER_API_KEY_DOCS_URL,
          external: true,
          onClick: () => this.onTrackHelpLinkClick(ACTIONS.CLICK_DEVELOPER_API_KEY_HELP),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.tryIt.dropdown.description.DEVELOPER_API_KEY"
          })
        });
      case AuthTypes.OAUTH_TOKEN:
        return /*#__PURE__*/_jsx(UILink, {
          href: OAUTH_DOCS_URL,
          external: true,
          onClick: () => this.onTrackHelpLinkClick(ACTIONS.CLICK_OAUTH_HELP),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.tryIt.dropdown.description.OAUTH_TOKEN"
          })
        });
      case AuthTypes.PRIVATE_APPS:
        return /*#__PURE__*/_jsx(UILink, {
          href: PRIVATE_APPS_URL,
          external: true,
          onClick: () => this.onTrackHelpLinkClick(ACTIONS.CLICK_PRIVATE_APPS_HELP),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.tryIt.dropdown.description.PRIVATE_APPS"
          })
        });
      default:
        return null;
    }
  }
  render() {
    const {
      children,
      authPopoverIsOpen,
      isConfirming
    } = this.props;
    return /*#__PURE__*/_jsx(UIPopover, {
      arrowSize: "none",
      autoPlacement: false,
      content: {
        body: this.renderPopoverBody(),
        footer: this.renderPopoverFooter()
      },
      open: authPopoverIsOpen || isConfirming,
      placement: "bottom left",
      use: "longform",
      width: 350,
      children: children && children
    });
  }
}
TryItPopover.propTypes = {
  children: PropTypes.element,
  securityTypes: PropTypes.arrayOf(AuthTypePropType).isRequired,
  doc: PropTypes.object.isRequired,
  authType: AuthTypePropType,
  authPopoverIsOpen: PropTypes.bool.isRequired,
  apiKey: PropTypes.string,
  oAuthToken: PropTypes.string,
  isConfirming: PropTypes.bool.isRequired,
  onSendRequestButtonClick: PropTypes.func.isRequired,
  onCancelButtonClick: PropTypes.func.isRequired
};
export default TryItPopover;